export default __webpack_public_path__ + "static/media/project-status-postponed.c495ff9d.svg";